import { render, staticRenderFns } from "./process3.vue?vue&type=template&id=0c436f0f&scoped=true&"
import script from "./process3.vue?vue&type=script&lang=js&"
export * from "./process3.vue?vue&type=script&lang=js&"
import style0 from "./process3.vue?vue&type=style&index=0&id=0c436f0f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c436f0f",
  null
  
)

export default component.exports